var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.516,
    height: 156.775,
    viewBox: "0 0 156.516 156.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(0 0.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2422956331008",
    transform: "translate(0 -0.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M145.283,40.385c-.145.735.036,3.149.009,4.092-.054,1.724-.345,1.878-.363,3.72-.027,2.913-.172,5.181-.327,8.176l-1.025,15.988c.064,6.188-.9,5.835-5.862,10.807L78.68,142.2c-5.562,5.562-2.849,5.825-17.522-8.847L19.137,91.335c-9.882-9.882-9.891-7.976-4.591-13.266,20.843-20.843,42.92-42.4,63.282-63.291,2.5-2.559,2.45-1.288,6.542-1.624l31.922-1.8c1.361-.181,1.8-.318,2.895.69.808.744,1.416,1.443,2.2,2.232,1.906,1.906,23.61,23.166,24.037,24.309.554,1.5-.009,1.152-.136,1.806ZM0,81.553c0,7.3,2.3,8.593,6.887,13.184L62,149.853c4.927,4.927,5.953,6.887,13.52,6.887,6.08,0,11.37-6.778,14.718-10.127L140.084,96.77c3.584-3.575,9.627-8.92,12.277-12.9,2.06-3.094,1.851-5.426,2.1-10.154.082-1.47.263-1.243.345-2.722.054-.989-.054-2.078,0-3.067.082-1.47.263-1.243.345-2.722.054-1.1-.064-2.3,0-3.4.082-1.47.263-1.243.345-2.722.054-.989-.054-2.078,0-3.067.082-1.47.263-1.243.345-2.722l.681-15.317a14.248,14.248,0,0,0-2.178-6.325L128.623,5.641c-5.708-5.236-6.288-6.2-15.335-5.453C111.854.305,110.43.1,108.978.3L76.5,2.528c-4.61,1.3-6.751,4.655-9.727,7.631l-60.4,60.4C3.748,73.187,0,76.481,0,81.526Z",
    transform: "translate(0 0.034)",
    fill: "#d9d9d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M122.788,52.072c-7.6,0-6.969-10.544-.336-10.544C129.539,41.528,129.639,52.072,122.788,52.072Zm-16.669-5.444c0,20.026,30.243,23.828,32.929.916a19.911,19.911,0,0,0-1.08-6.57c-2.178-5.5-7.677-10.344-13.82-10.344-5.127,0-9.609.653-13.538,4.836a17.745,17.745,0,0,0-4.5,11.152Z",
    transform: "translate(-9.826 -2.805)",
    fill: "#d9d9d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M53.24,87.309v1.7c0,2.849,4.936,7.586,9.782,2.641L80.879,74.116c7.54-6.642,2.94-12-2.123-12-3.04,0-11.116,9.246-13.52,11.651-2.2,2.2-12,10.97-12,13.52Z",
    transform: "translate(-4.93 -5.721)",
    fill: "#d9d9d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M75.74,110.837c0,2.659,2.259,5.444,4.764,5.444,3.457,0,3.312-.073,6.043-2.8,6.488-6.506,13.3-12.876,19.4-19.727a3.726,3.726,0,0,0,1.152-2.6,5.406,5.406,0,0,0-1.651-4.909c-2.6-2.368-5.771-1.769-8.321.726L78.381,105.991C77.01,107.353,75.74,108.215,75.74,110.837Z",
    transform: "translate(-7.014 -7.816)",
    fill: "#d9d9d9",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryDefault);
export default __webpack_public_path__ + "static/media/CategoryDefault.6f164428900a19380d2745e85078aaf0.svg";
export { ForwardRef as ReactComponent };